<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="12" class="">
        <div class="Timeline">
          <svg style="vertical-align: baseline" height="5" width="33%">
            <line
              x1="0"
              y1="0"
              x2="100%"
              y2="0"
              style="stroke-width: 5"
              :style="`stroke: ${entityConfig.primaryColor} `"
            />
          </svg>
          <div class="event1">
            <svg style="vertical-align: baseline" height="20" width="20">
              <circle
                cx="10"
                cy="11"
                r="9"
                :fill="`${entityConfig.primaryColor} `"
              />
            </svg>
          </div>

          <svg style="vertical-align: baseline" height="5" width="33%">
            <line
              x1="0"
              y1="0"
              x2="100%"
              y2="0"
              style="stroke-width: 5"
              :style="`stroke: ${entityConfig.secondaryColor} `"
            />
          </svg>
          <div class="event1">
            <svg style="vertical-align: baseline" height="20" width="20">
              <circle
                cx="10"
                cy="11"
                r="9"
                :fill="`${entityConfig.secondaryColor} `"
              />
            </svg>
          </div>

          <svg style="vertical-align: baseline" height="5" width="33%">
            <line
              x1="0"
              y1="0"
              x2="100%"
              y2="0"
              style="stroke-width: 5"
              :style="`stroke: ${entityConfig.secondaryColor} `"
            />
          </svg>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" sm="6" md="6" class="">
        <small
          :style="`color: ${entityConfig.primaryColor} `"
          style="
            display: block;
            padding-left: 35%;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 0.19px;
            line-height: 24px;
            text-align: center;
          "
        >
          {{ $t("progres.datosEmpresa") }}
        </small>
      </v-col>
      <v-col cols="6" sm="6" md="6" class="d-flex align-center">
        <small
          style="
            display: block;
            padding-left: 24%;
            color: #353b42;
            font-size: 16px;
            letter-spacing: 0.19px;
            line-height: 24px;
            text-align: center;
          "
          >{{ $t("progres.datosAcceso") }}
        </small>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "progres",
  data() {
    return {
      entityConfig: {},
    };
  },

  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
  },
};
</script>
<style lang="sass" scoped></style>
